export function getOffsetTop(element: HTMLElement, container: any): number {
  if (!element) {
    return 0;
  }

  if (!element.getClientRects().length) {
    return 0;
  }

  const rect = element.getBoundingClientRect();

  if (rect.width || rect.height) {
    if (container === window) {
      container = element.ownerDocument!.documentElement!;
      return rect.top - container.clientTop;
    }
    return rect.top - (container as HTMLElement).getBoundingClientRect().top;
  }

  return rect.top;
}

export function easeInOutCubic(t: number, b: number, c: number, d: number) {
  const cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }
  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}

export function getContainerScrollTop(container: HTMLElement) {
  return container.scrollTop;
}

export function getAllScrollTops(elements: (HTMLElement | null)[]) {
  return [].map.call(elements, (element, index) => {
    if (!element) {
      return 0;
    }
    return (element as HTMLElement).offsetTop;
  });
}

export function getScrollTopOfIndex(index: number) {
  const elements = document.querySelectorAll('.personal-profile, .abs-container .abs-panel');
  return (elements[index] as HTMLElement).offsetTop;
}

export function scrollTo(href: string, container: HTMLElement, callback: () => void) {
  const element = getElementByHref(href) as HTMLElement;
  const scrollTop = container.scrollTop;
  const startTime = Date.now();

  let targetScrollTop = element.offsetTop;

  const frameFunc = () => {
    const timestamp = Date.now();
    const time = timestamp - startTime;
    const nextScrollTop = easeInOutCubic(time, scrollTop, targetScrollTop, 450);

    container.scrollTop = nextScrollTop;
    
    if (time < 450) {
      requestAnimationFrame(frameFunc);
    } else {
      callback();
    }
  };
  requestAnimationFrame(frameFunc);
}

export function getElementByHref(href: string) {
  const sharpMatcherRegx = /#([^#]+)$/;
  const result = sharpMatcherRegx.exec(href);
  if (result) {
    const dom = document.getElementById(result[1]);
    return dom;
  }
  return null;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAnchorPoint/utils.ts